module.exports = function getResource(label, vars = []) {
    let resources = {
        preSelectedAnswersNotification: 'Any pre-selected answers are based on information you’ve previously provided—please update them if needed.',
        gotItButtonLabel: 'Got it!'
    };

    return resources[label];
};
